import Tabs from 'antd-mobile/lib/tabs';
export default Tabs;



// WEBPACK FOOTER //
// ./components/tabs/index.tsx